import { render } from "./AchievingGoals.vue?vue&type=template&id=2306d2df&scoped=true"
import script from "./AchievingGoals.vue?vue&type=script&lang=js"
export * from "./AchievingGoals.vue?vue&type=script&lang=js"

import "./AchievingGoals.vue?vue&type=style&index=0&id=2306d2df&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2306d2df"]])

export default __exports__